import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';

const PartnersSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  // Partner logos - using the local image files
  const partnerLogos = [
    {
      name: 'GE Vernova',
      logo: '/images/ge-vernova-logo.png',
      description: {
        fr: 'Leader mondial en technologie d\'énergie et d\'instrumentation industrielle',
        ar: 'شركة رائدة عالميًا في تكنولوجيا الطاقة والقياس الصناعي',
        en: 'Global leader in energy technology and industrial instrumentation'
      }
    },
    {
      name: 'Irma Global Services',
      logo: '/images/irma-global-services.png',
      description: {
        fr: 'Services d\'ingénierie et solutions de maintenance pour l\'industrie du Pétrole, Gaz et Industrie',
        ar: 'خدمات هندسية وحلول صيانة لصناعة النفط والغاز والصناعة',
        en: 'Engineering services and maintenance solutions for the Oil, Gas and Industry sector'
      }
    },
    {
      name: 'Baker Hughes',
      logo: '/images/baker-hughes-logo.png',
      description: {
        fr: 'Technologies avancées pour l\'industrie pétrolière et gazière',
        ar: 'تقنيات متقدمة لصناعة النفط والغاز',
        en: 'Advanced technologies for the oil and gas industry'
      }
    },
    {
      name: 'Panametrics',
      logo: '/images/panametrics-logo.png',
      description: {
        fr: 'Solutions de mesure de précision pour les applications industrielles critiques',
        ar: 'حلول قياس دقيقة للتطبيقات الصناعية الحرجة',
        en: 'Precision measurement solutions for critical industrial applications'
      }
    },
    {
      name: 'Hobré Analyzer Solutions',
      logo: '/images/hobre-logo.png',
      description: {
        fr: 'Leader mondial des analyseurs BTU pour torchères et mesure de combustion des gaz industriels',
        ar: 'الرائد عالمياً في محلل BTU للمشاعل وقياس احتراق الغازات الصناعية',
        en: 'Global leader in BTU analyzers for flares and industrial gas combustion measurement'
      }
    }
  ];

  const getLanguageText = (textObj) => {
    return textObj[language] || textObj.fr || textObj.en;
  };

  return (
    <section className="section section-light" style={{ 
      padding: '6rem 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        right: '5%',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '5%',
        left: '5%',
        width: '250px',
        height: '250px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.03) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ 
        position: 'relative', 
        zIndex: 2,
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1.5rem'
      }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '3rem'
        }}>
          <span style={{
            display: 'inline-block',
            padding: '0.5rem 1.5rem',
            backgroundColor: 'rgba(255, 107, 0, 0.1)',
            color: 'var(--assco-orange)',
            borderRadius: '30px',
            fontWeight: '600',
            fontSize: '0.875rem',
            marginBottom: '1rem',
            textTransform: 'uppercase'
          }}>
            {language === 'fr' ? 'COLLABORATIONS STRATÉGIQUES' : 
             language === 'ar' ? 'تعاون استراتيجي' : 
             'STRATEGIC COLLABORATIONS'}
          </span>

          <h2 className="fade-in" style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            marginBottom: '1.5rem',
            color: '#1a202c',
            position: 'relative',
            display: 'inline-block'
          }}>
            {language === 'fr' ? 'Nos Partenaires de Confiance' : 
             language === 'ar' ? 'شركاؤنا الموثوقون' : 
             'Our Trusted Partners'}
            <span style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: 'var(--assco-orange)',
              borderRadius: '2px'
            }}></span>
          </h2>
          
          <p className="fade-in" style={{ 
            color: 'var(--assco-gray-600)', 
            maxWidth: '700px', 
            margin: '0 auto',
            fontSize: '1.125rem',
            lineHeight: '1.7'
          }}>
            {language === 'fr' 
              ? 'Nous sommes fiers de collaborer avec des leaders mondiaux de l\'industrie pour vous offrir des solutions d\'instrumentation de la plus haute qualité.' 
              : language === 'ar' 
              ? 'نحن فخورون بالتعاون مع الشركات الرائدة عالميًا في الصناعة لتقديم حلول قياس ذات أعلى جودة لك.' 
              : 'We are proud to collaborate with global industry leaders to bring you the highest quality instrumentation solutions.'}
          </p>
        </div>
        
        <div className="partners-carousel" style={{
          position: 'relative',
          padding: '3rem 0'
        }}>
          {/* Decorative line */}
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '0',
            right: '0',
            height: '2px',
            backgroundColor: 'var(--assco-gray-100)',
            zIndex: 1
          }}></div>
          
          <div className="partners-grid fade-in" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '2rem',
            position: 'relative',
            zIndex: 2
          }}>
            {partnerLogos.map((partner, index) => (
              <div 
                key={index}
                className="partner-card"
                style={{
                  backgroundColor: 'white',
                  borderRadius: '20px',
                  boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                  overflow: 'hidden',
                  transition: 'all 0.3s ease',
                  border: '1px solid var(--assco-gray-100)',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
                  e.currentTarget.style.borderColor = 'var(--assco-orange)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
                  e.currentTarget.style.borderColor = 'var(--assco-gray-100)';
                }}
              >
                <div style={{
                  backgroundColor: 'var(--assco-gray-50)',
                  padding: '1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '180px',
                  position: 'relative',
                  overflow: 'hidden'
                }}>
                  {/* Background pattern */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                    opacity: 0.5
                  }}></div>
                  
                  {/* Partner logo */}
                  <div style={{
                    position: 'relative',
                    zIndex: 2,
                    width: '90%',
                    height: '90%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0.5rem'
                  }}>
                    <img 
                      src={partner.logo} 
                      alt={partner.name} 
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                        transition: 'all 0.3s ease',
                        filter: 'grayscale(0%)',
                        opacity: 1
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.filter = 'grayscale(0%)';
                        e.currentTarget.style.opacity = '1';
                        e.currentTarget.style.transform = 'scale(1.05)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.filter = 'grayscale(0%)';
                        e.currentTarget.style.opacity = '1';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    />
                  </div>
                  
                  {/* Partner badge */}
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    backgroundColor: 'rgba(255, 107, 0, 0.1)',
                    color: 'var(--assco-orange)',
                    padding: '0.25rem 0.75rem',
                    borderRadius: '20px',
                    fontSize: '0.75rem',
                    fontWeight: '600'
                  }}>
                    {language === 'fr' ? 'PARTENAIRE' : 
                     language === 'ar' ? 'شريك' : 
                     'PARTNER'}
                  </div>
                </div>
                
                <div style={{
                  padding: '1.5rem',
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <h3 style={{
                    fontSize: '1.25rem',
                    fontWeight: '700',
                    marginBottom: '0.75rem',
                    color: 'var(--assco-gray-900)'
                  }}>
                    {partner.name}
                  </h3>
                  
                  <p style={{
                    fontSize: '0.95rem',
                    color: 'var(--assco-gray-600)',
                    lineHeight: '1.6',
                    flex: 1
                  }}>
                    {getLanguageText(partner.description)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Partnership banner */}
        <div className="partnership-banner fade-in" style={{
          marginTop: '4rem',
          position: 'relative',
          borderRadius: '2rem',
          overflow: 'hidden',
          background: 'linear-gradient(135deg, #ffffff 0%, #fef9f5 50%, #fff2e5 100%)',
          border: '2px solid rgba(255, 107, 0, 0.1)',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.8)'
        }}>
          {/* Decorative background elements */}
          <div style={{
            position: 'absolute',
            top: '-50px',
            right: '-50px',
            width: '200px',
            height: '200px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.1) 0%, rgba(255, 140, 0, 0.05) 100%)',
            opacity: 0.6
          }}></div>
          <div style={{
            position: 'absolute',
            bottom: '-80px',
            left: '-80px',
            width: '300px',
            height: '300px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.05) 0%, rgba(255, 140, 0, 0.02) 100%)',
            opacity: 0.8
          }}></div>
          
          {/* Floating geometric shapes */}
          <div style={{
            position: 'absolute',
            top: '15%',
            left: '10%',
            width: '20px',
            height: '20px',
            backgroundColor: 'rgba(255, 107, 0, 0.2)',
            borderRadius: '50%',
            animation: 'float 6s ease-in-out infinite'
          }}></div>
          <div style={{
            position: 'absolute',
            top: '60%',
            right: '15%',
            width: '15px',
            height: '15px',
            backgroundColor: 'rgba(255, 140, 0, 0.15)',
            borderRadius: '2px',
            transform: 'rotate(45deg)',
            animation: 'float 8s ease-in-out infinite reverse'
          }}></div>
          
          <div style={{
            padding: '4rem 2.5rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            position: 'relative',
            zIndex: 2
          }}>
            {/* Enhanced icon container */}
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #ffffff 0%, #fef9f5 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 2rem',
              boxShadow: '0 20px 40px -12px rgba(255, 107, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.9)',
              border: '3px solid rgba(255, 107, 0, 0.1)',
              position: 'relative'
            }}>
              {/* Icon glow effect */}
              <div style={{
                position: 'absolute',
                inset: '-10px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.2) 0%, transparent 70%)',
                filter: 'blur(15px)',
                opacity: 0.7,
                zIndex: -1
              }}></div>
              <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" fill="none" viewBox="0 0 24 24" stroke="var(--assco-orange)">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            
            {/* Enhanced title */}
            <h3 style={{
              fontSize: '2.5rem',
              fontWeight: '800',
              marginBottom: '1.5rem',
              background: 'linear-gradient(135deg, var(--assco-gray-900) 0%, #4a4a4a 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              lineHeight: '1.2',
              position: 'relative'
            }}>
              {language === 'fr' ? 'Intéressé par un partenariat?' : 
               language === 'ar' ? 'مهتم بالشراكة؟' : 
               'Interested in partnership?'}
              
              {/* Decorative underline */}
              <div style={{
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '100px',
                height: '4px',
                background: 'linear-gradient(90deg, var(--assco-orange) 0%, #ff8c00 100%)',
                borderRadius: '2px',
                opacity: 0.8
              }}></div>
            </h3>
            
            {/* Enhanced description */}
            <p style={{
              fontSize: '1.25rem',
              color: 'var(--assco-gray-700)',
              maxWidth: '750px',
              margin: '0 auto 2.5rem',
              lineHeight: '1.8',
              fontWeight: '400'
            }}>
              {language === 'fr' 
                ? 'Nous sommes toujours ouverts à de nouvelles collaborations stratégiques. Contactez-nous pour discuter des opportunités de partenariat.' 
                : language === 'ar' 
                ? 'نحن منفتحون دائمًا على تعاونات استراتيجية جديدة. اتصل بنا لمناقشة فرص الشراكة.' 
                : 'We are always open to new strategic collaborations. Contact us to discuss partnership opportunities.'}
            </p>
            
            {/* Benefits list */}
            <div style={{
              display: 'flex',
              gap: '2rem',
              marginBottom: '3rem',
              flexWrap: 'wrap',
              justifyContent: 'center'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                backgroundColor: 'rgba(255, 107, 0, 0.08)',
                padding: '0.75rem 1.25rem',
                borderRadius: '50px',
                border: '1px solid rgba(255, 107, 0, 0.15)'
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="var(--assco-orange)">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                <span style={{ color: 'var(--assco-gray-800)', fontWeight: '600', fontSize: '0.95rem' }}>
                  {language === 'fr' ? 'Croissance rapide' : language === 'ar' ? 'نمو سريع' : 'Fast Growth'}
                </span>
              </div>
              
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                backgroundColor: 'rgba(255, 107, 0, 0.08)',
                padding: '0.75rem 1.25rem',
                borderRadius: '50px',
                border: '1px solid rgba(255, 107, 0, 0.15)'
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="var(--assco-orange)">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span style={{ color: 'var(--assco-gray-800)', fontWeight: '600', fontSize: '0.95rem' }}>
                  {language === 'fr' ? 'Support 24/7' : language === 'ar' ? 'دعم 24/7' : '24/7 Support'}
                </span>
              </div>
              
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                backgroundColor: 'rgba(255, 107, 0, 0.08)',
                padding: '0.75rem 1.25rem',
                borderRadius: '50px',
                border: '1px solid rgba(255, 107, 0, 0.15)'
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="var(--assco-orange)">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
                <span style={{ color: 'var(--assco-gray-800)', fontWeight: '600', fontSize: '0.95rem' }}>
                  {language === 'fr' ? 'Prix compétitifs' : language === 'ar' ? 'أسعار تنافسية' : 'Competitive Prices'}
                </span>
              </div>
            </div>
            
            {/* Enhanced CTA button */}
            <button style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.75rem',
              background: 'linear-gradient(135deg, var(--assco-orange) 0%, #ff8c00 100%)',
              color: 'white',
              padding: '1.125rem 2.5rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1.125rem',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              boxShadow: '0 20px 40px -12px rgba(255, 107, 0, 0.4), 0 8px 16px -4px rgba(255, 107, 0, 0.3)',
              position: 'relative',
              overflow: 'hidden'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px) scale(1.02)';
              e.currentTarget.style.boxShadow = '0 30px 60px -12px rgba(255, 107, 0, 0.5), 0 12px 24px -4px rgba(255, 107, 0, 0.4)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0) scale(1)';
              e.currentTarget.style.boxShadow = '0 20px 40px -12px rgba(255, 107, 0, 0.4), 0 8px 16px -4px rgba(255, 107, 0, 0.3)';
            }}
            >
              {/* Button shine effect */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: '-100%',
                width: '100%',
                height: '100%',
                background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
                transition: 'left 0.5s'
              }}></div>
              
              {language === 'fr' ? 'Contactez-nous' : 
               language === 'ar' ? 'اتصل بنا' : 
               'Contact us'}
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @media (max-width: 768px) {
          .partners-grid {
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
          }
        }
      `}</style>
    </section>
  );
};

export default PartnersSection;